export default __webpack_public_path__ + "images/40_thumbnail.jpg";